import { render, staticRenderFns } from "./company-detail-form.vue?vue&type=template&id=73657310"
import script from "./company-detail-form.vue?vue&type=script&lang=js"
export * from "./company-detail-form.vue?vue&type=script&lang=js"
import style0 from "./company-detail-form.vue?vue&type=style&index=0&id=73657310&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports